import "../cta.js";

window.Sparkle ??= {};
window.Sparkle.MobileCTA ??= {};

Sparkle.MobileCTA.Inline = class Inline extends Sparkle.MobileCTA.CTA {
  constructor(cta, options) {
    super(cta, options);
    if (options == null) {
      options = {};
    }
    this.scrollPadding = options.scrollPadding; // The amount of space to leave at the top of the screen when scrolling to the element
    this.buffer = options.buffer; // The distance off the screen the element must be in order to show this teaser

    if (this.getMinHeightToShowCTA() < this.getTopOffset()) {
      return;
    }
  }

  // DSL

  activate() {
    return window.scrollTo({
      top: this.getTopOffset(),
      behavior: "smooth",
    });
  }

  // HELPERS

  getTopOffset() {
    let topOffset = this.element.offset().top;
    if (this.scrollPadding) {
      topOffset = topOffset - this.scrollPadding;
    }

    return topOffset;
  }

  getMinHeightToShowCTA() {
    let height = window.innerHeight;
    if (this.buffer) {
      height = height + this.buffer;
    }

    return height;
  }
};
